// extracted by mini-css-extract-plugin
export default {"cardSec":"CertificateActivityLogs_cardSec__lzLF-","certificateImgSec":"CertificateActivityLogs_certificateImgSec__Bko+v","downloadBtn":"CertificateActivityLogs_downloadBtn__p-5Bb"};